<template>
  <v-dialog
    width="800"
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    persistent
    scrollable
  >
    <AddAutomationDialog :opened.sync="addAutomationDialogOpened" />

    <v-card>
      <v-card-title class="title py-2">
        <v-layout align-start> Automations </v-layout>

        <v-spacer />

        <v-btn
          color="primary"
          class="text-capitalize"
          @click="addAutomationDialogOpened = true"
        >
          <v-icon small class="pr-2">add</v-icon>
          New Automation
        </v-btn>

        <v-btn
          small
          flat
          fab
          class="white error--text text-capitalize"
          @click="$emit('update:opened', false)"
        >
          <v-icon size="24"> clear </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-3 text-xs-left">
        <div
          v-for="(automation, index) of automations"
          class="automation-container"
        >
          <div class="grey--text label">Automation {{ automation.id }}:</div>

          <div class="description">
            For <b>{{ automation.target }}</b
            >, when they <b>{{ automation.condition }}</b
            >, then <b>{{ automation.action }}.</b>

            <span class="more" v-if="automation.more"
              >Show more<v-icon small>arrow_drop_down</v-icon></span
            >
          </div>

          <v-btn small color="primary" class="text-none px-3 ml-0">
            Edit flow
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AddAutomationDialog from '@/components/dialogs/AddAutomationDialog';

export default {
  components: {
    AddAutomationDialog,
  },

  props: {
    opened: {
      type: Boolean,
    },
  },

  data() {
    return {
      addAutomationDialogOpened: false,

      automations: [
        {
          id: 1,
          target: 'clients that are assigned to me',
          condition: 'sign the Engagement letter',
          action: 'create a to-do task',
          more: true,
        },
        {
          id: 2,
          target: 'clients to whom I subscribed',
          condition: 'upload documents in Soraban',
          action: 'send an notification to my email',
          more: false,
        },
        {
          id: 3,
          target: 'clients to whom I subscribed',
          condition: 'completed questionnaire and make the payment',
          action: 'create a to-do task',
          more: true,
        },
      ],
    };
  },
};
</script>

<style lang="postcss" scoped>
.title {
  font-weight: bold;
  letter-spacing: 0px !important;
  border-bottom: 1px solid #ccc;
}

.automation-container {
  padding: 16px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 16px;

  & >>> .label {
    font-size: 14px;
    padding-bottom: 8px;
  }

  & >>> .description {
    padding-bottom: 8px;
    color: #666;
  }

  & >>> .more {
    padding-bottom: 8px;
    color: #4f7eea;
    cursor: pointer;
  }

  & >>> b {
    font-weight: 400;
    color: #000;
  }
}
</style>
